/**
 * react-scroll animateScroll の ラップ関数
 * https://github.com/fisshy/react-scroll
 */
import { animateScroll as scroll, scroller } from 'react-scroll';
/**
 * 対象までスクロールする（座標）
 * @param toY
 * @param options
 */
export const scrollTo = (toY, options) => {
    scroll.scrollTo(toY, options);
};
/**
 * 対象までスクロールする（Element）
 * @param name 対象の Element に設定した name
 * @param options
 */
export const scrollToElement = (name, options) => {
    scroller.scrollTo(name, options);
};
